import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import * as JWT from 'jwt-decode';
import { BASE_API_URL, AUTH_USER_STORAGE, AUTH_TOKEN_STORAGE } from '../../config/app.config';
import { StorageFactory } from '../storage/storage.factory';
import {AuthTokenService} from "@core/auth/auth-token.service";

@Injectable()
export class AuthService {

  constructor(private http: HttpClient, private storage: StorageFactory, private authTokenService: AuthTokenService) {

  }

  isLoggedIn(): boolean {
    let authUser = this.getAuthUser();

    return !!authUser;
  }

  isAdmin(): boolean {
    return this.hasRole('System Administrator');
  }

  getAuthUser() {
    const token = this.storage.getItem(AUTH_USER_STORAGE);

    if (token) {
      let user = JWT(token);
      // console.log("User: " + JSON.stringify(user, null, '\t'));
      return user;
    }
  }

  hasRole(role) {
    let authUser = this.getAuthUser();
    let hasRole = false;

    let keystone_authorization = authUser && JSON.parse(authUser.keystone_authorization);

    let roles = keystone_authorization && keystone_authorization.Roles;

    if (roles) {
      hasRole = roles.some(r => {
        return r.Name === role;
      });
    }

    return hasRole;
  }

  login() {
    window.location.href = BASE_API_URL + 'auth/login?redirect=web';
  }

  processLogin(code) {
    if (!code) {
      return;
    }

    return new Promise((resolve, reject) => {
      this.http.post(BASE_API_URL + 'auth/token', {}, {
        params: new HttpParams().set('code', code).set('devicetoken', 'none').set('phone', 'none').set('redirect', 'web')
      }).toPromise().then(result => {
        console.log(result);
        this.authTokenService.storeToken(result);
        resolve(true);
        //window.location.href = '/areas';
      }).catch(err => {
        reject(err);
      });
    });
  }

  logout() {
    return new Promise((resolve, reject) => {
      this.http.post(BASE_API_URL + 'auth/logout', {}, {
        params: new HttpParams().set('redirect', 'web')
      }).toPromise()
      .then(result => {
        console.log("Logging out - ");
        console.log(result);
        this.authTokenService.removeToken();
        resolve();
      })
      .catch(err => {
        console.log("Error Logging out:");
        console.log(err);
        this.authTokenService.removeToken();
        reject(err);
      });
    });
  }

}



// WEBPACK FOOTER //
// D:/dclean-web-latest/cot-web/src/app/core/auth/auth.service.ts